/**
 * @generated SignedSource<<02c20bfb5ff29b992e5e45d6d7de59e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CategoryTypes = "body_care" | "child_teaching" | "dance" | "diet" | "diy" | "fashion" | "gadget" | "game" | "gourmet_sweet_report" | "hair_care" | "kids" | "life_style" | "makeup" | "movie" | "nail" | "other" | "pet" | "ranking" | "skin_care" | "travel" | "yoga";
import { FragmentRefs } from "relay-runtime";
export type CampaignFilter$data = {
  readonly mCategories: ReadonlyArray<{
    readonly id: string;
    readonly keyName: CategoryTypes;
    readonly name: string;
  }>;
  readonly prefectures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly regionName: string;
  }>;
  readonly " $fragmentType": "CampaignFilter";
};
export type CampaignFilter$key = {
  readonly " $data"?: CampaignFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignFilter">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCategory",
      "kind": "LinkedField",
      "name": "mCategories",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "keyName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MPrefecture",
      "kind": "LinkedField",
      "name": "prefectures",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "regionName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cf2150e7ae7f27dfa40c0cd75ade698a";

export default node;
